export default "__VITE_ASSET__CdXaH0tG__"